<mat-drawer-container class="d-block m-0 p-0 h-100">
  <mat-drawer *ngIf="false"
              [ngClass]="['side-nav-panel', screenSize]"
              [mode]="sideNavMode"
              [opened]="sideNavOpen">
    SideNav
    {{screenSize}}
  </mat-drawer>
  <mat-drawer-content>
    <layout-content-header
      [customButtonsTemplate]="headerButtonsTemplate"
      [lastNavigationItemTemplate]="lastNavigationItemTemplate"
      [breadcrumbs]="breadcrumbs"
    ></layout-content-header>
    <div [ngClass]="currentNavigationRouteItemNgClass">
      <route-container
        [uid]="'root'"
        (routerOutletChange)="onRouterContainerChange($event)"
      ></route-container>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
